import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useViews (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('viewsChanged', callback),
    () => state.views
  )
}
